import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
export type PostReactionFragment = { hasReacted?: boolean | null, reaction: string, count: number, userIds: Array<string>, users?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null };


export type PostReactionFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PostReactionFragmentDoc = /*#__PURE__*/ gql`
    fragment PostReaction on ReactionType {
  hasReacted
  reaction
  count
  users {
    ...User
  }
  userIds
}
    `;